import React from 'react'

export default props => (
    <div className="nav-tabs-custom">
        {props.children}
    </div>
)


// WEBPACK FOOTER //
// ./src/common/tab/tabs.jsx